<template>
  <div class="vdp-datepicker">
    <vue-datepicker
      ref="picker"
      v-bind="$attrs"
      :model-value="modelValue"
      :language="language"
      :hide-input="false"
      @update:model-value="$emit('update:modelValue', $event)"
      @input="$emit('input', $event)"
    />
  </div>
</template>

<script>
import VueDatepicker from 'vuejs3-datepicker';

// Retain the existing input, Japanese locale and imperative calendar API.
export default {
  components: { VueDatepicker },
  inheritAttrs: false,
  props: {
    modelValue: { type: [Date, String, Number], default: null },
    language: { type: String, default: 'ja' },
  },
  emits: ['update:modelValue', 'input'],
  methods: {
    showCalendar() {
      this.$refs.picker.showCalendar();
    },
    close(emitEvent) {
      this.$refs.picker.close(emitEvent);
    },
  },
};
</script>
